var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread-container"},[_c('div',{staticClass:"bread"},[_c('crumb',{class:{
                'crumb--first': true,
            },attrs:{"route":_vm.dashboardRoute}}),_vm._l((_vm.routes),function(route,index){return _c(_vm.getCrumbType(route),{key:route.name,tag:"component",attrs:{"last":index === _vm.routes.length - 1,"route":route}})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }